<template>
    <router-link
        style="font-size: 28px; font-weight: bold; color: black"
        :to="{ path: `/customer/complain/${id}` }"
    >
        <div id="post">
            {{ title }}

            <div class="row align-space-between" style="margin-top: 16px">
                <p style="font-size: 20px; font-weight: normal; color: #5f5f5f">
                    {{ category }}
                </p>
                <p style="font-size: 20px; font-weight: normal; color: #5f5f5f">
                    {{ postDate }}
                </p>
            </div>
        </div>
    </router-link>
</template>

<script>
import { ref, defineComponent, onMounted } from "vue";

export default defineComponent({
    props: {
        title: {
            type: String,
            default: "",
        },
        category: {
            type: String,
            default: "",
        },
        date: {
            type: String,
            default: "",
        },
        id: {
            type: String,
        },
        onClick: Function,
    },
    setup(props) {
        const postDate = ref("");
        const formatKoreanDate = (dateString) => {
            const date = new Date(dateString);
            return date
                .toLocaleDateString("ko-KR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                })
                .replace(/\. /g, "-")
                .slice(0, -1); // 한국 형식은 보통 "YYYY. MM. DD." 이므로 이를 변환합니다.
        };

        onMounted(() => {
            postDate.value = formatKoreanDate(props.date);
        });

        return { formatKoreanDate, postDate };
    },
});
</script>

<style scoped>
button {
    padding: 8px 16px;
    border: 0.5px solid black;
    border-radius: 20px;
}

#post {
    width: 100%;
    padding: 16px 24px;
    border-bottom: 1px solid #b3b3b3;
    cursor: pointer;
}
</style>
